import { rankings } from "@/mocks/homeContent";

export default function RankingList() {
  return (
    <section id="dig" className="mx-auto max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
      <div className="rounded-xl bg-foreground-950 p-7 text-background-50 md:p-10">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.3em] text-accent-400">本期起底 · 热度盘点</p>
            <h3 className="mt-2 font-heading text-2xl font-bold md:text-3xl">深度热榜 TOP 5</h3>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-background-100/60">
            按站内阅读与讨论热度综合排序，均附完整复盘与多源核验。
          </p>
        </div>

        <ol className="mt-8 divide-y divide-background-100/10 border-t border-background-100/10">
          {rankings.map((r) => (
            <li key={r.rank}>
              <a href="#review" className="group grid grid-cols-1 items-center gap-2 py-5 transition-colors sm:grid-cols-[70px_1fr_auto] sm:gap-6">
                <span className="font-heading text-3xl font-black leading-none text-accent-400/90 md:text-4xl">{r.rank}</span>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="whitespace-nowrap rounded-full bg-background-100/10 px-2.5 py-0.5 text-[11px] tracking-wide text-accent-300">{r.tag}</span>
                    <h4 className="font-heading text-base font-semibold leading-snug text-background-50 transition-colors group-hover:text-accent-300 md:text-lg">
                      {r.title}
                    </h4>
                  </div>
                  <p className="mt-1.5 hidden text-sm text-background-100/55 sm:block">{r.snippet}</p>
                </div>
                <span className="flex items-center gap-1 whitespace-nowrap text-xs text-background-100/55">
                  <i className="ri-fire-line text-accent-400" /> {r.heat.toLocaleString()}
                </span>
              </a>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}